import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export const OrderConfirmedBadge = (props: BadgeProps): React.ReactElement => {
  return (
    <Badge
      {...props}
      icon={"CHECK_CIRCLE"}
      className={twMerge("bg-emerald-100 text-emerald-700", props.className)}
    >
      Order finalised
    </Badge>
  );
};
